export async function CreateLog(transactionId, order, request, response) {
  try {
    const apiUrl = process.env.REACT_APP_CreateLog;
    const data = {
      transactionId: transactionId,
      order: order,
      request: request,
      response: response      
    };

    console.log(data);

    const responseUrl = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify( data )
    });

    if (!responseUrl.ok) throw new Error('Error al obtener datos');
    
    return await responseUrl.json();
  } catch (error) {
    console.error('Error al llamar al API:', error);
    throw error;
  }
}
